import { NotFoundError } from 'interface-store';
import { BaseBlockstore } from './base.js';
// https://github.com/multiformats/multicodec/blob/d06fc6194710e8909bac64273c43f16b56ca4c34/table.csv#L2
const IDENTITY_CODEC = 0x00;
export class IdentityBlockstore extends BaseBlockstore {
    child;
    constructor(child) {
        super();
        this.child = child;
    }
    put(key, block) {
        if (key.multihash.code === IDENTITY_CODEC) {
            return key;
        }
        if (this.child == null) {
            return key;
        }
        return this.child.put(key, block);
    }
    get(key) {
        if (key.multihash.code === IDENTITY_CODEC) {
            return key.multihash.digest;
        }
        if (this.child == null) {
            throw new NotFoundError();
        }
        return this.child.get(key);
    }
    has(key) {
        if (key.multihash.code === IDENTITY_CODEC) {
            return true;
        }
        if (this.child == null) {
            return false;
        }
        return this.child.has(key);
    }
    delete(key) {
        if (key.code === IDENTITY_CODEC) {
            return;
        }
        if (this.child != null) {
            return this.child.delete(key);
        }
    }
    getAll(options) {
        if (this.child != null) {
            return this.child.getAll(options);
        }
        return [];
    }
}
//# sourceMappingURL=identity.js.map